<script lang="ts" setup>
import {
  Carousel,
  CarouselContent,
  CarouselNext,
  CarouselPrevious,
  CarouselControlsBackgroundPrev,
  CarouselControlsBackgroundNext,
  CarouselItem
} from '@toni/brand-ui'
import { usePageStore } from '@toni/rendering/src/stores/page'
import { useConfigStore } from '@toni/rendering/src/stores/config'

import { type MenuItem } from '../../../utils/content-block-schema/header-schema'
import { createImgSrc, getImgDefinitions } from '../../bauer-image/image-utils'
import TrendingMenuItem from './TrendingMenuItem.vue'

defineProps<{
  items: MenuItem[]
}>()

const brand = usePageStore().brandFromStore as string
const imageServiceUrl = useConfigStore().rsConfig.imageServiceUrl as string
const imageSrcDefinitions = useConfigStore().rsConfig.imageSrcDefinitions
const setName = 'trending-icon' as string
const imageDefinitions = getImgDefinitions(brand, imageSrcDefinitions, setName)
const imgFallbackWidth = imageDefinitions.maxWidth ?? imageSrcDefinitions?.maxWidth ?? 0

const imgSrc = (item: MenuItem) => {
  if (!item.icon) return undefined
  // Set proper width and height with https://bauer-specialist.atlassian.net/jira/software/c/projects/TCDW/boards/229?selectedIssue=TCDW-345
  return createImgSrc({
    image: item.icon,
    brand,
    imageServiceUrl,
    imageSrcDefinitions,
    setName: 'trending_icon'
  }, imgFallbackWidth)?.href ?? ''
}
</script>

<template>
  <div class="py-3 bg-trending-background px-5">
    <Carousel variant="simple"
              align="start">
      <CarouselContent class="gap-4">
        <CarouselItem v-for="(item, index) in items"
                      :key="index">
          <TrendingMenuItem :img-src="imgSrc(item)"
                            :alt="item.icon?.imageAltText"
                            :href="item.url"
                            :target="item.target">
            {{ item.name }}
          </TrendingMenuItem>
        </CarouselItem>
      </CarouselContent>
      <CarouselControlsBackgroundPrev :show-when-cannot-scroll="false">
        <CarouselPrevious class="h-4 w-4 -left-3"
                          size="sm"
                          :use-disabled-opacity="false"
                          :show-when-cannot-scroll="false" />
      </CarouselControlsBackgroundPrev>
      <CarouselControlsBackgroundNext :show-when-cannot-scroll="false">
        <CarouselNext class="h-4 w-4 -right-3"
                      size="sm"
                      :use-disabled-opacity="false"
                      :show-when-cannot-scroll="false" />
      </CarouselControlsBackgroundNext>
    </Carousel>
  </div>
</template>
